import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';
import "../../../resources/styles.scss";
import * as cardsStyles from '../cards.module.scss';
import { selectApplicationSettings } from '../../../state/selectors/app'
import cardTypes from '../../../constants/cardTypes';
import InputForProperty from '../../../components/inputs/inputForProperty';
import SelectForProperty from '../../../components/inputs/selectForProperty';
import cloneDeep from 'lodash.clonedeep';
import cardService from '../../../services/userCardService';
import CardLimits from '../Limits/card_limits';
import log from '../../../services/logger/log';

const emptyCard = {
    userCardId: "00000000-0000-0000-0000-000000000000",
    cardNumber: "",
    cardNumberInternal: 0,
    cardIButtonNumber: "",
    userName: "",
    description: "",
    userPin: 0,
    isActive: true,
};

const EditUserCard = (props) => {
    const { match, history, t, location } = props;
    const [card, setCard] = useState(Object.assign({}, emptyCard));
    const [isNewCard, setIsNewCard] = useState(false);
    const [limits, setLimits] = useState([]);
    const appSettings = useSelector(store => selectApplicationSettings()(store))
    const isLimitsAvailable = !!appSettings.find(s => s.name === "LimitsAvailable")?.value;

    const backToPage = "/cards/users";

    useEffect(() => {
        const cardId = match.params.id ? match.params.id : 0;
        getCard(cardId);
    }, []);

    const getCard = async (cardId) => {
        if (cardId === 0) {
            setLimits([]);
            setIsNewCard(true);
            setCard({ ...emptyCard });
            return;
        }
        const c = await cardService.getCardAsync(cardId);
        const lim = c.cardLimits.map((limit) => {
            return {
                item: limit,
                isEditable: false
            }
        });

        setCard(c.card);
        setLimits(lim);
    }

    const updateCardProps = (propName, propValue) => {
        const state = Object.assign({}, card);
        state[propName] = propValue;
        setCard(state);
    }

    const setCardInternalNumber = (value) => {
        const state = Object.assign({}, card);
        const num = !value || value === '' ? 0 : parseInt(value);
        if (num < 0 || num > 99999999) return;

        state.cardNumberInternal = value;

        setCard(state);
    }

    const setUserPin = (value, e) => {
        const state = cloneDeep(card);
        const num = !value || value === '' ? 0 : parseInt(value);
        if (num < 0 || num > 9999) {
            e.preventDefault();
            return;
        }

        state.userPin = value;
        setCard(state);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const limts = limits.map(limit => { return limit.item });
        var requestBody = { card: card, limits: limts };

        try {
            if (card.userCardId === emptyCard.userCardId) {
                await cardService.addCardAsync(requestBody);
            } else {
                await cardService.editCardAsync(requestBody);
            }

            history.replace(backToPage);
        } catch (error) {
            log.error(JSON.stringify(error));
        }
    }

    const cancelEditCard = (e) => {
        e.preventDefault();
        history.replace(backToPage);
    }

    return (
        <div className="form_container">
            <form className="edit-card-form" onSubmit={handleSubmit}>
                <div className={`form-body ${isLimitsAvailable ? 'flex-row-border-content' : ''}`}>
                    <div id="cardEdit">
                        <div className="margin10">
                            <div style={{ position: 'relative' }} className={cardsStyles.card_limit_header}>
                                <div>
                                    <Trans>{isNewCard ? 'Cards.newCardHeader' : 'Cards.editCardHeader'}</Trans>
                                </div>
                            </div>
                            <p>
                                <SelectForProperty header={t("Cards.cardType")}
                                    disabled={true}
                                    value={cardTypes.USER}
                                    options={[{ label: t("Cards.avtoCardType"), value: cardTypes.AVTO }, { label: t("Cards.userCardType"), value: cardTypes.USER }]} />
                            </p>
                            <p>
                                <InputForProperty type="text"
                                    header={t("Cards.cardRfidNumber")}
                                    propertyName="cardNumber" value={card.cardNumber}
                                    onChange={(val) => updateCardProps("cardNumber", val)}></InputForProperty>
                            </p>
                            <p>
                                <InputForProperty type="text"
                                    header={t("Cards.cardIButtonNumber")}
                                    value={card.cardIButtonNumber}
                                    onChange={(val) => updateCardProps("cardIButtonNumber", val)}></InputForProperty>
                            </p>
                            <p>
                                <InputForProperty type="number"
                                    header={t("Cards.cardNumber")}
                                    value={card.cardNumberInternal}
                                    onChange={(val) => setCardInternalNumber(val)}></InputForProperty>
                            </p>
                            <p>
                                <InputForProperty type="text"
                                    header={t("Cards.userName")}
                                    value={card.userName}
                                    onChange={(val) => updateCardProps("userName", val)}></InputForProperty>
                            </p>
                            <p>
                                <InputForProperty type="number"
                                    header={t("Cards.userPin")}
                                    value={card.userPin}
                                    onChange={(value, e) => setUserPin(value, e)}></InputForProperty>
                            </p>
                            <p>
                                <InputForProperty type="text"
                                    header={t("Cards.description")}
                                    value={card.description}
                                    onChange={(val) => updateCardProps("description", val)}></InputForProperty>
                            </p>
                        </div>
                    </div>
                    <CardLimits userCardId={card.userCardId} limits={limits} setLimits={setLimits} />
                </div>
                <div className="form-buttons-container">
                    <button type="submit"><Trans>Table.saveButton</Trans></button>
                    <button onClick={cancelEditCard}><Trans>Table.cancelButton</Trans></button>
                </div>
            </form>
        </div>
    );
}

export default withRouter((withTranslation("translations")(EditUserCard)));
